import {
  FindAddress,
  RetrieveAddress,
  SelectedItemProps,
} from "../types/autocomplete";

export const FindAddressApiResponseMock1: FindAddress[] = [
  {
    Id: "US|US|B|Z222408617|444",
    Type: "Address",
    Text: "444 Laurel St",
    Highlight: "0-3",
    Description: "San Carlos CA 94070",
  },
  {
    Id: "US|US|ENG|94070-CA-SAN_CARLOS--ST-LAUREL--444",
    Type: "BuildingNumber",
    Text: "444 Laurel St",
    Highlight: "0-3",
    Description: "San Carlos CA 94070 - 2 Addresses",
  },
];

export const FindAddressMock1: SelectedItemProps[] = [
  {
    id: "US|US|B|Z222408617|444",
    type: "Address",
    value: "444 Laurel St",
    label: "444 Laurel St San Carlos CA 94070",
  },
  {
    id: "US|US|ENG|94070-CA-SAN_CARLOS--ST-LAUREL--444",
    type: "BuildingNumber",
    value: "444 Laurel St",
    label: "444 Laurel St San Carlos CA 94070 - 2 Addresses",
  },
];

export const FindAddressApiResponseMock2: FindAddress[] = [
  {
    Id: "US|US|B|Z222408618|A",
    Type: "Address",
    Text: "444 Laurel St Apt A",
    Highlight: "",
    Description: "San Carlos CA 94070",
  },
  {
    Id: "US|US|B|Z222408618|B",
    Type: "Address",
    Text: "444 Laurel St Apt B",
    Highlight: "",
    Description: "San Carlos CA 94070",
  },
];

export const FindAddressMock2: SelectedItemProps[] = [
  {
    id: "US|US|B|Z222408617|444",
    type: "Address",
    value: "444 Laurel St Apt A",
    label: "444 Laurel St Apt A San Carlos CA 94070",
  },
  {
    id: "US|US|B|Z222408618|B",
    type: "Address",
    value: "444 Laurel St Apt B",
    label: "444 Laurel St Apt B San Carlos CA 94070",
  },
];

export const RetrieveAddressMock: RetrieveAddress = {
  Id: "US|US|B|Z222408617|444",
  DomesticId: "Z222408617",
  Language: "ENG",
  LanguageAlternatives: "ENG",
  Department: "",
  Company: "",
  SubBuilding: "",
  BuildingNumber: "444",
  BuildingName: "",
  SecondaryStreet: "",
  Street: "Laurel St",
  Block: "",
  Neighbourhood: "",
  District: "",
  City: "San Carlos",
  Line1: "444 Laurel St",
  Line2: "",
  Line3: "",
  Line4: "",
  Line5: "",
  AdminAreaName: "San Mateo",
  AdminAreaCode: "081",
  Province: "CA",
  ProvinceName: "California",
  ProvinceCode: "CA",
  PostalCode: "94070-2421",
  CountryName: "United States",
  CountryIso2: "US",
  CountryIso3: "USA",
  CountryIsoNumber: "840",
  SortingNumber1: "",
  SortingNumber2: "",
  Barcode: "",
  POBoxNumber: "",
  Label: "444 Laurel St\nSAN CARLOS CA 94070-2421\nUNITED STATES",
  Type: "Residential",
  DataLevel: "Range",
  Field1: "",
  Field2: "",
  Field3: "",
  Field4: "",
  Field5: "",
  Field6: "",
  Field7: "",
  Field8: "",
  Field9: "",
  Field10: "",
  Field11: "",
  Field12: "",
  Field13: "",
  Field14: "",
  Field15: "",
  Field16: "",
  Field17: "",
  Field18: "",
  Field19: "",
  Field20: "",
};
